import {
  ANNUAL_REPORT_GET_YOUTH_ADVISORY_COUNCIL,
  ANNUAL_REPORT_POST_YOUTH_ADVISORY_COUNCIL
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

export const getYouthAdvisoryCouncil =
  (AssociationNumber, BranchNumber, year) => (dispatch, getState) =>
    asyncRequest({
      url: ANNUAL_REPORT_GET_YOUTH_ADVISORY_COUNCIL(
        AssociationNumber,
        BranchNumber,
        year
      ),
      successAction: data => ({
        type: types.GET_YOUTH_ADVISORY_COUNCIL_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.GET_YOUTH_ADVISORY_COUNCIL_FAILURE,
        payload: error
      }),
      dispatch
    });

export const postYouthAdvisoryCouncil = bodyObject => (dispatch, getState) =>
  asyncRequest({
    url: ANNUAL_REPORT_POST_YOUTH_ADVISORY_COUNCIL(),
    method: 'POST',
    data: bodyObject,
    successAction: data => ({
      type: types.POST_YOUTH_ADVISORY_COUNCIL_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.POST_YOUTH_ADVISORY_COUNCIL_FAILURE,
      payload: error
    }),
    dispatch
  });
